import {STATE_PROP_NAME} from './story-modal-constants'

export const getState = state => state[STATE_PROP_NAME]
